export default __webpack_public_path__ + "static/media/geology-earth.61d2b324.png";